"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultErrorMessages = void 0;
exports.getDefaultErrorMessages = (singular, plural) => ({
    list: `Error while loading ${plural || singular + 's'}`,
    detail: `Error while loading ${singular}`,
    insert: `Error while trying to insert ${singular}`,
    update: `Error whilie updating ${singular}`,
    delete: `Error while deleting ${singular}`
});
